import { render, staticRenderFns } from "./new-object.vue?vue&type=template&id=4afd9b12&scoped=true"
import script from "./new-object.vue?vue&type=script&lang=ts"
export * from "./new-object.vue?vue&type=script&lang=ts"
import style0 from "./new-object.vue?vue&type=style&index=0&id=4afd9b12&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afd9b12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4afd9b12')) {
      api.createRecord('4afd9b12', component.options)
    } else {
      api.reload('4afd9b12', component.options)
    }
    module.hot.accept("./new-object.vue?vue&type=template&id=4afd9b12&scoped=true", function () {
      api.rerender('4afd9b12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/objects/new-object.vue"
export default component.exports